import { useRouter } from 'next/router'

import PageHeader from 'app/PemetaanKompetensiPage/components/AsesmenRefleksi/PageHeader'
import EligibilityGuard from 'app/PemetaanKompetensiPage/components/EligibilityGuard'
import RefleksiKompetensiErrorBoundary from 'app/PemetaanKompetensiPage/components/RefleksiKompetensiErrorBoundary'
import Main from 'app/PemetaanKompetensiPage/pages/AsesmenRefleksi/Main'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer },
  }
}

const PageAsesmenRefleksi = ({ currentDateTimeServer }) => (
  <RefleksiKompetensiErrorBoundary>
    <EligibilityGuard currentDateTimeServer={currentDateTimeServer}>
      <Main currentDateTimeServer={currentDateTimeServer} />
    </EligibilityGuard>
  </RefleksiKompetensiErrorBoundary>
)

const PageHeaderAsesmenRefleksi = () => {
  const router = useRouter()
  return (
    <PageHeader
      leftActionFunction={() => {
        router.replace('/refleksi-kompetensi')
      }}
      title="Refleksi Kompetensi"
    />
  )
}

PageAsesmenRefleksi.layoutOpts = {
  className: 'text-default bg-white !h-full min-h-screen !max-w-full ',
  hasHeader: true,
  header: PageHeaderAsesmenRefleksi,
}

export default PageAsesmenRefleksi
